import { render, staticRenderFns } from "./EditorDialog.vue?vue&type=template&id=13f2a979&scoped=true"
import script from "./EditorDialog.ts?vue&type=script&lang=ts&external"
export * from "./EditorDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2a979",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f2a979')) {
      api.createRecord('13f2a979', component.options)
    } else {
      api.reload('13f2a979', component.options)
    }
    module.hot.accept("./EditorDialog.vue?vue&type=template&id=13f2a979&scoped=true", function () {
      api.rerender('13f2a979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/S3Connector/components/EditorDialog/EditorDialog.vue"
export default component.exports